import { useState } from "react";
import { Label } from "@/components/ui/label";
import { Upload } from "lucide-react";
import { compressImage } from "@/utils/imageCompression";

interface BannerUploadProps {
  onBannerChange: (file: File) => void;
}

export const BannerUpload = ({ onBannerChange }: BannerUploadProps) => {
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);

  const handleBannerChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const compressedFile = await compressImage(file);
      onBannerChange(compressedFile);
      const url = URL.createObjectURL(compressedFile);
      setPreviewUrl(url);
    }
  };

  return (
    <div className="space-y-2">
      <Label htmlFor="banner">Startup Banner (Optional)</Label>
      <div className="relative h-48 rounded-xl bg-gradient-to-r from-flux-purple/20 to-flux-blue/20 group">
        {previewUrl ? (
          <img 
            src={previewUrl} 
            alt="Banner preview"
            className="w-full h-full object-cover rounded-xl"
          />
        ) : (
          <div className="w-full h-full flex flex-col items-center justify-center">
            <div className="text-4xl font-bold text-flux-cyan/50">FLUXVOID</div>
            <p className="text-xs text-gray-400 mt-2">This default banner is not endorsed by Fluxvoid</p>
          </div>
        )}
        <label className="absolute inset-0 flex items-center justify-center bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity cursor-pointer">
          <input
            type="file"
            accept="image/*"
            onChange={handleBannerChange}
            className="hidden"
          />
          <Upload className="w-6 h-6 text-white" />
        </label>
      </div>
    </div>
  );
};